import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { allData } from "../api/data";

const AllData = ({ close }) => {
  const [filter, setFilter] = useState("daily");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchData(page);
    const interval = setInterval(() => fetchData(page), 300000);
    return () => clearInterval(interval);
  }, [filter, startDate, endDate, page]);

  const fetchData = async (currentPage) => {
    try {
      setLoading(true);
      const response = await allData(filter, startDate, endDate, currentPage, limit);

      if (response.status === "success") {
        setData(response.data || []);
        const totalItems = response.pagination?.total_records || 0;
        setTotalPages(Math.max(1, Math.ceil(totalItems / limit)));
      } else {
        console.error("Error fetching data:", response.message);
      }
    } catch (error) {
      console.error("Unexpected error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle pagination
  const handleNextPage = () => {
    if (page < totalPages) setPage((prev) => prev + 1);
  };

  const handlePrevPage = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  return (
    <div className="popup-overlay">
      <motion.div
        className="popup-layer"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      >
        <div className="title">
          View all Data
          <button onClick={close}>Close</button>
        </div>

        <div className="filter-header">
          <select value={filter} onChange={(e) => setFilter(e.target.value)}>
            <option value="daily">This Day</option>
            <option value="weekly">This Week</option>
            <option value="monthly">This Month</option>
            <option value="yearly">This Year</option>
          </select>
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </div>

        <div className="table-container">
          {loading ? (
            <>
              <p className='load-text'>Loading table data...</p>
              <div className="loader">
                <div className="waves"></div>
              </div>
            </>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Main Tank Temperature</th>
                  <th>Reservoir Temperature</th>
                  <th>Pitcher Temperature</th>
                  <th>Heating</th>
                  <th>Cooling</th>
                  <th>Date</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={index}>
                      <td>{item.peltierTemp || "-"}</td>
                      <td>{item.reservoirTemp || "-"}</td>
                      <td>{item.pitcherTemp || "-"}</td>
                      <td>{item.heating === 1 ? "On" : "Off"}</td>
                      <td>{item.cooling === 1 ? "On" : "Off"}</td>
                      <td>{item.created_at?.split(" ")[0] || "-"}</td>
                      <td>{item.created_at?.split(" ")[1] || "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">No data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        <div className="pagination">
          <button
            onClick={() => setPage((prev) => prev - 1)}
            disabled={page === 1}
          >
            Previous
          </button>

          <button
            onClick={() => setPage((prev) => prev + 1)}
            disabled={page < totalPages}
          >
            Next
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default AllData;
